import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionGuidesCategoryPageData } from '#src/app/pages/petitionGuides/category/details/pageContext';
import { CategoryChips } from '#src/app/pages/petitionGuides/shared/components/CategoryChips';

import { ArticleList } from './components/ArticleList';
import { CategoryBreadcrumbs } from './components/CategoryBreadcrumbs';
import { CategoryPagination } from './components/CategoryPagination';
import { CTASection } from './components/CTASection';

const EmptyState: React.FC = () => (
	<div className="container space-y-2 text-center">
		<Text as="h2" variant="heading" size="small">
			<Translate value="corgi.petition_guides_category_page.empty_state.heading" />
		</Text>
		<Text>
			<Translate value="corgi.petition_guides_category_page.empty_state.description" />
		</Text>
	</div>
);

export const PageBody: React.FC = () => {
	const {
		data: { slug, categories, articles },
	} = usePetitionGuidesCategoryPageData();
	const track = useTracking();

	return (
		<div className="container mt-10 mb-16 space-y-16">
			<div className="space-y-6">
				<CategoryChips
					categories={categories}
					currentSlug={slug}
					onCategoryClick={(categorySlug) => {
						// `category_slug` is already set by this page's TrackingContext to the *current*
						// category (see pageContext/provider.tsx), and call-site properties win over context
						// properties — so the clicked-chip destination goes under `slug` instead.
						void track('petition_guides_category_page_category_chip_click', { slug: categorySlug });
					}}
				/>
				{articles.length === 0 ? (
					<EmptyState />
				) : (
					<>
						<ArticleList />
						<CategoryPagination />
					</>
				)}
			</div>
			<CTASection />
			<CategoryBreadcrumbs />
		</div>
	);
};
